const GA_TRACKING = true;

export const event = {
  HOMEPAGE_PV: 'HOMEPAGE_PV',
  HOMEPAGE_CLICKS: 'HOMEPAGE_CLICKS',
  BOOKINGS_PV: 'BOOKINGS_PV',
  BOOKINGS_CLICKS: 'BOOKINGS_CLICKS',
  POI_PV: 'POI_PV',
  POI_CLICKS: 'POI_CLICKS',
  DELIVERY_DETAILS_PV: 'DELIVERY_DETAILS_PV',
  DELIVERY_DETAILS_CLICKS: 'DELIVERY_DETAILS_CLICKS',
  BULK_UPLOAD_PV: 'BULK_UPLOAD_PV',
  BULK_UPLOAD_CLICKS: 'BULK_UPLOAD_CLICKS',
  BULK_UPLOAD_REVIEW_PV: 'BULK_UPLOAD_REVIEW_PV',
  BULK_UPLOAD_REVIEW_CLICKS: 'BULK_UPLOAD_REVIEW_CLICKS',
  BULK_UPLOAD_EDIT_ADDRESS_PV: 'BULK_UPLOAD_EDIT_ADDRESS_PV',
  BULK_UPLOAD_EDIT_ADDRESS_CLICKS: 'BULK_UPLOAD_EDIT_ADDRESS_CLICKS',
};

export const cat = {
  GE_HOMEPAGE: 'GE_HOMEPAGE',
  GE_BOOKINGS: 'GE_BOOKINGS',
  GE_POI_SEARCH: 'GE_POI_SEARCH',
  GE_DELIVERY_DETAILS: 'GE_DELIVERY_DETAILS',
  GE_BULK_UPLOAD: 'GE_BULK_UPLOAD',
  GE_BULK_UPLOAD_REVIEW: 'GE_BULK_UPLOAD_REVIEW',
  GE_BULK_UPLOAD_EDIT_ADDRESS: 'GE_BULK_UPLOAD_EDIT_ADDRESS',
};

export const action = {
  CLICK_LEFT: 'CLICK_LEFT',
  PAGE_VIEW: 'PAGE_VIEW',
};

export const custom = {
  COMPANY_ID: 'COMPANY_ID',
};

export const track = (e, c, a, l, extra = {}) => {
  const data = {
    event: e,
    CATEGORY: c,
    ACTION: a,
    LABEL: l,
    ...extra,
  };
  if (GA_TRACKING) {
    window.pushGAEvent(data);
  }
  // Scribe SDK implementation here later
};

export const trackClick = (e, c, l, extra) =>
  track(e, c, action.CLICK_LEFT, l, extra);

export const trackPageView = (e, c, extra) =>
  track(e, c, action.PAGE_VIEW, 'DEFAULT', extra);
